<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    This is dashboard
  </div>
</template>

<script>

export default {
  name: 'Dashboard',
  components: {
  }
};
</script>
